module.exports = __webpack_public_path__ + "static/building-microservices-f914ecad04241f8ade8c328cc87265a4.jpg";